import { render, staticRenderFns } from "./SubscriptionTypeModal.vue?vue&type=template&id=32b521ad&scoped=true&"
import script from "./SubscriptionTypeModal.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionTypeModal.vue?vue&type=style&index=0&id=32b521ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b521ad",
  null
  
)

export default component.exports